export const PASSWORD_REGEX = /^.{8,24}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9-_]+\.[A-Za-z]+$/;

export const ENDPOINT_ACCOUNT_REGISTER = '/account/signup';
export const ENDPOINT_ACCOUNT_SIGN_IN = '/account/signin';
export const ENDPOINT_ACCOUNT_SIGN_OUT = '/account/signout';
export const ENDPOINT_ACCOUNT_REFRESH_TOKEN = '/account/refresh';
export const ENDPOINT_ACCOUNT_EMAIL_VERIFY = '/account/emailVerification';
export const ENDPOINT_ACCOUNT_RESET_PASSWORD = '/account/resetpassword';
export const ENDPOINT_ACCOUNT_UPDATE = '/account/update';
export const ENDPOINT_ACCOUNT_BILLING_PORTAL = '/account/billingportal';

export const ENDPOINT_GROUPS = '/event';

export const ENDPOINT_COMPONENT = '/{groupId}/component';
export const ENDPOINT_GALLERY = '/{groupId}/gallery';
export const ENDPOINT_FRAME_PRESIGNED_UPLOAD = '/{groupId}/preSignedS3UploadPath';

export const ENDPOINT_MESSAGE = '/{groupId}/invitation/message';
export const ENDPOINT_INVITATIONS_LIST = '/{groupId}/invitation/load';
export const ENDPOINT_INVITATIONS_SEND = '/{groupId}/invitation/sendInvitation';
export const ENDPOINT_INVITATIONS_SET_AUTO_REMINDER = '/{groupId}/invitation/addAutoReminder';
export const ENDPOINT_INVITATIONS_SEND_REMINDER = '/{groupId}/invitation/reSend';
export const ENDPOINT_INVITATIONS_SEND_REMINDER_ALL = '/{groupId}/invitation/reSendAll';
export const ENDPOINT_INVITATIONS_EXCLUDE_REMINDER = '/{groupId}/invitation/excludeReminder';
export const ENDPOINT_CVENT_CONNECT = '/integration/cvent/oauth/validate';
export const ENDPOINT_CVENT_OAUTH_CONNECT = '/integration/{groupId}/cvent/generate-auth-url';
export const ENDPOINT_CVENT_LIST_SPEAKERS = '/integration/{groupId}/cvent/speakers';